import { FORBIDDEN_STATUS_CODE } from '@constants/api.ts';
import { ALREADY_REGISTERED_STATUS } from '@routes/auth/register/constants.ts';

interface UserStatusError {
    data: {
        status: string;
    };
    status: number;
}

export const isUserAlreadyRegistered = (userStatusError: UserStatusError) =>
    userStatusError?.status === FORBIDDEN_STATUS_CODE && userStatusError?.data?.status === ALREADY_REGISTERED_STATUS;
